import React from 'react';
import { number, string } from 'prop-types';
const EllipsisSvg = ({width, fillColor='black', className}) => {
  const radius = width / 8;
  const height = width * .375;
  return (
    <svg height={height} width={width} className={className}>
      <circle cx={width * .1875} cy={height / 2} r={radius} fill={fillColor} />
      <circle cx={width * .5} cy={height / 2} r={radius} fill={fillColor} />
      <circle cx={width * .8125} cy={height / 2} r={radius} fill={fillColor} />
    </svg> 
  );
};

EllipsisSvg.propTypes = {
  width: number,
  fillColor: string,
  className: string
};

export default EllipsisSvg;